import React, { useEffect, useState } from 'react';
import './FicheTopsportAtleet.scss';
import { MoreInfo } from '../../MoreInfo/MoreInfo';
import { Image } from '../../../Image/Image';
import { FicheType } from '../../FicheType/FicheType';

export const FicheTopsportAtleet = (props) => {

    const [bodyItems, setBodyItems] = useState([]);

    //Processs body items
    useEffect(() => {
        const newBodyItems = [];
        const naam = props.data.title.split(' ')[0];
        props.data.body.items.forEach((item, index) => {
            var newItem = { ...item };
            if (newItem.text) {
                newItem.text = props.dictionary[item.text.replaceAll("-", "").replaceAll(" ", "").toLowerCase()];
            }
            else if (newItem.icon.includes("facebook")) {
                newItem.text = `Volg ${naam} op Facebook`;
            }
            else if (newItem.icon.includes("twitter")) {
                newItem.text = `Volg ${naam} op Twitter`;
            }
            else if (newItem.icon.includes("instagram")) {
                newItem.text = `Volg ${naam} op Instagram`;
            }
            newBodyItems.push(newItem);
        });
        let items = props.processFicheItems(newBodyItems);
        setBodyItems(items);
    }, [JSON.stringify(props.data.body.items)]);

    return <div className="c-fiche c-groepsaankopen-full" data-aos="fade-up">
        <div>
            <FicheType type={props.data.type}>
                <i class="fa-fw fa-fw fas fa-calendar-alt"></i>
            </FicheType>
            {
                props.data.image && <div className="image" title="Meer over">
                    <Image alt={props.data.title} src={(props.data.image && props.data.image.url)} />
                </div>
            }
            <header className="c-fiche__header">
                <h2 className="title" title={props.title}>
                    {props.data.title}
                </h2>
                {props.data.text}
            </header>
            <div className="c-fiche__body">
                <ul>
                    {bodyItems}
                </ul>
            </div>
        </div>
    </div>;
}